/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_LabelInputs */



/**
* | output |
* | --- |
* | "Export Video with AD" |
*
* @param {Audio_Description_Export_Video_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_label = /** @type {((inputs?: Audio_Description_Export_Video_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la vidéo avec AD")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video mit Werbung exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta video con AD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видео с рекламой")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar vídeo con AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出带广告的视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADでビデオをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विज्ञापन के साथ वीडियो निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar vídeo com anúncios")
	return /** @type {LocalizedString} */ ("Export Video with AD")
});